
import { Options, Vue, prop } from "vue-class-component";
import Checkbox from "primevue/checkbox";
import Search from "@/app/ui/components/search/index.vue";
import DateRangePicker from "@/app/ui/components/date-range-picker/index.vue";
import PillOverlay from "@/app/ui/components/pill-overlay/index.vue";
import { Range } from "@/app/ui/components/date-range-picker/type";
import {
  HandoverV2Detail,
  ResultsPanelFilter
} from "@/domain/entities/HandoverV2";
import { OptionsClass } from "@/domain/entities/MainApp";

class Props {
  modelValue = prop<ResultsPanelFilter>({
    default: () => new ResultsPanelFilter(),
    type: Object
  });
  rows = prop<HandoverV2Detail[]>({ default: () => [], type: Array });
}

@Options({
  components: { Search, DateRangePicker, PillOverlay, Checkbox },
  emits: ["update:modelValue"]
})
class ScanRekonResultsFilter extends Vue.with(Props) {
  dateRangeModel = new Range();
  pendingPresetDays: number | null = null;
  tempPriorities: string[] = [];

  onSearchInput(value: string): void {
    this.$emit("update:modelValue", { ...this.modelValue, keyword: value });
  }

  onSearchClear(): void {
    this.$emit("update:modelValue", { ...this.modelValue, keyword: "" });
  }

  get productOptions() {
    const unique = new Map(
      this.rows.map((r) => [
        r.stt.sttProductType,
        new OptionsClass({
          name: r.stt.sttProductType,
          value: r.stt.sttProductType
        })
      ])
    );
    return [
      new OptionsClass({
        name: this.$t("handoverV2.update.common.all"),
        value: ""
      }),
      ...unique.values()
    ];
  }
  onSelectProduct(item: OptionsClass) {
    this.$emit("update:modelValue", {
      ...this.modelValue,
      product: item.value
    });
  }

  get commodityOptions() {
    const unique = new Map(
      this.rows.map((r) => [
        r.stt.sttCommodityCode,
        new OptionsClass({
          name: r.stt.sttCommodityName,
          value: r.stt.sttCommodityCode
        })
      ])
    );
    return [
      new OptionsClass({
        name: this.$t("handoverV2.update.common.all"),
        value: ""
      }),
      ...unique.values()
    ];
  }
  onSelectCommodity(item: OptionsClass) {
    this.$emit("update:modelValue", {
      ...this.modelValue,
      commodity: item.value
    });
  }
}

export default ScanRekonResultsFilter;
